(function () {
  function setAnnouncementBarHeight() {
    const bar = document.querySelector('.announcement-bar-section');
    const height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setAnnouncementBarHeight);
  } else {
    setAnnouncementBarHeight();
  }

  window.addEventListener('resize', setAnnouncementBarHeight);

  const bar = document.querySelector('.announcement-bar-section');
  if (bar && window.ResizeObserver) {
    new ResizeObserver(setAnnouncementBarHeight).observe(bar);
  }
})();
